<template>
    <div class="meta-referral-list">
        <div class="meta-referral-header">
            <h3>Reklam Etkileşimleri</h3>
            <div class="meta-referral-filter">
                <input type="text" v-model="searchQuery" placeholder="Reklam ara..." />
                <select v-model="filterStatus">
                    <option value="">Tüm Durumlar</option>
                    <option value="ACTIVE">Aktif</option>
                    <option value="CAMPAIGN_PAUSED">Kampanya Duraklatıldı</option>
                    <option value="PAUSED">Duraklatıldı</option>
                    <option value="ARCHIVED">Arşivlenmiş</option>
                </select>
            </div>
        </div>

        <div v-if="filteredReferrals.length === 0" class="empty-container">
            <i class="fas fa-info-circle"></i>
            <p v-if="searchQuery || filterStatus">Arama kriterlerinize uygun reklam etkileşimi bulunamadı.</p>
            <p v-else>Henüz hiç reklam etkileşimi bulunmuyor.</p>
        </div>
        
        <div v-else class="referrals-container">
            <div class="referral-card" v-for="referral in filteredReferrals" :key="referral._id">
                <div class="referral-header">
                    <div class="referral-title">
                        <span class="date-badge">{{ formatDate(referral.createdAt) }}</span>
                        <h4 v-if="referral.headline">{{ referral.headline }}</h4>
                        <h4 v-else>Meta Reklam</h4>
                    </div>
                    <div class="referral-badges">
                        <span class="source-badge" :class="referral.sourceType">{{ referral.sourceType }}</span>
                        <span
                            v-if="referral.adInfo && referral.adInfo.effective_status"
                            class="status-badge"
                            :class="getStatusClass(referral.adInfo.effective_status)"
                        >
                            {{ getStatusText(referral.adInfo.effective_status) }}
                        </span>
                    </div>
                </div>

                <div class="referral-body">
                    <p v-if="referral.body">{{ referral.body }}</p>

                    <div v-if="referral.adInfo" class="ad-details">
                        <div class="detail-item">
                            <div class="detail-label">
                                <i class="fas fa-ad"></i>
                                <span>Reklam:</span>
                            </div>
                            <div class="detail-value" v-tippy :title="referral.adInfo.name || '-'">
                                {{ referral.adInfo.name || "-" }}
                            </div>
                        </div>

                        <div class="detail-item">
                            <div class="detail-label">
                                <i class="fas fa-layer-group"></i>
                                <span>Reklam Seti:</span>
                            </div>
                            <div class="detail-value" v-tippy :title="getAdSetName(referral)">
                                {{ getAdSetName(referral) }}
                            </div>
                        </div>

                        <div class="detail-item">
                            <div class="detail-label">
                                <i class="fas fa-bullhorn"></i>
                                <span>Kampanya:</span>
                            </div>
                            <div class="detail-value" v-tippy :title="getCampaignName(referral)">
                                {{ getCampaignName(referral) }}
                            </div>
                        </div>

                        <div v-if="referral.adInfo.account_id" class="detail-item">
                            <div class="detail-label">
                                <i class="fas fa-user-circle"></i>
                                <span>Hesap ID:</span>
                            </div>
                            <div class="detail-value">
                                {{ referral.adInfo.account_id }}
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="referral.sourceLink" class="referral-footer">
                    <a :href="referral.sourceLink" target="_blank" rel="noopener noreferrer" class="view-link">
                        <i class="fas fa-external-link-alt"></i>
                        Reklamı Görüntüle
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MetaReferralList",
    props: {
        contact: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            metaReferrals: [],
            searchQuery: "",
            filterStatus: "",
        };
    },
    computed: {
        filteredReferrals() {
            let filtered = this.metaReferrals;

            // Arama metni filtresi
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                filtered = filtered.filter((ref) => {
                    return (
                        (ref.headline && ref.headline.toLowerCase().includes(query)) ||
                        (ref.body && ref.body.toLowerCase().includes(query)) ||
                        (ref.adInfo && ref.adInfo.name && ref.adInfo.name.toLowerCase().includes(query)) ||
                        (ref.adInfo &&
                            ref.adInfo.adset &&
                            ref.adInfo.adset.name &&
                            ref.adInfo.adset.name.toLowerCase().includes(query)) ||
                        (ref.adInfo &&
                            ref.adInfo.campaign &&
                            ref.adInfo.campaign.name &&
                            ref.adInfo.campaign.name.toLowerCase().includes(query))
                    );
                });
            }

            // Durum filtresi
            if (this.filterStatus) {
                filtered = filtered.filter((ref) => {
                    return ref.adInfo && ref.adInfo.effective_status === this.filterStatus;
                });
            }

            // Tarihe göre sıralama (en yeniden en eskiye)
            return filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        },
    },
    methods: {
        formatDate(dateString) {
            return this.$moment(dateString).format("DD MMM YYYY");
        },
        getAdSetName(referral) {
            return this.$_.get(referral, "adInfo.adset.name", "-");
        },
        getCampaignName(referral) {
            return this.$_.get(referral, "adInfo.campaign.name", "-");
        },
        getStatusClass(status) {
            if (status === "ACTIVE") return "active";
            if (status === "CAMPAIGN_PAUSED" || status === "PAUSED") return "paused";
            if (status === "ARCHIVED") return "archived";
            return "unknown";
        },
        getStatusText(status) {
            if (status === "ACTIVE") return "Aktif";
            if (status === "CAMPAIGN_PAUSED") return "Kampanya Duraklatıldı";
            if (status === "PAUSED") return "Duraklatıldı";
            if (status === "ARCHIVED") return "Arşivlenmiş";
            return status || "-";
        },
    },
    created() {
        this.metaReferrals = this.contact.metaReferrals || [];
    },
};
</script>

<style lang="scss" scoped>
.meta-referral-list {
    font-family: "Poppins", sans-serif;
    padding: 24px;
    background-color: #f9fafb;
    height: 100%;
    overflow-y: auto;

    .meta-referral-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
        flex-wrap: wrap;
        gap: 16px;
        background-color: white;
        padding: 18px 20px;
        border-radius: 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        border: 1px solid #eaecf0;

        h3 {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            margin: 0;
        }

        .meta-referral-filter {
            display: flex;
            gap: 12px;

            input,
            select {
                padding: 10px 14px;
                border: 1px solid #e0dbf0;
                border-radius: 8px;
                font-size: 14px;
                outline: none;
                background-color: #fafafa;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
                transition: all 0.2s ease;

                &:focus {
                    border-color: #674ea7;
                    box-shadow: 0 0 0 3px rgba(103, 78, 167, 0.1);
                    background-color: white;
                }

                &::placeholder {
                    color: #9ca3af;
                }
            }

            input {
                width: 250px;
            }

            select {
                min-width: 180px;
                background-color: #fff;
                cursor: pointer;
                
                &:hover {
                    border-color: #d1c4e9;
                }
            }
        }
    }

    .empty-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 300px;
        color: #888;
        text-align: center;
        background-color: white;
        border-radius: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        border: 1px solid #eaecf0;
        padding: 40px 20px;
        margin: 10px 0;

        i {
            font-size: 48px;
            margin-bottom: 20px;
            color: #674ea7;
            opacity: 0.6;
        }

        p {
            margin: 10px 0 0;
            font-size: 16px;
            max-width: 400px;
            line-height: 1.5;
        }
    }

    .referrals-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
        gap: 24px;

        .referral-card {
            background-color: #fff;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            overflow: hidden;
            transition: all 0.3s ease;
            border: 1px solid #e0dbf0;
            display: flex;
            flex-direction: column;

            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
                border-color: #c7b8e6;
            }

            .referral-header {
                padding: 20px;
                border-bottom: 1px solid #f0ebff;
                background-color: #f8f6ff;

                .referral-title {
                    margin-bottom: 12px;

                    .date-badge {
                        display: inline-block;
                        font-size: 12px;
                        color: #674ea7;
                        background-color: rgba(103, 78, 167, 0.1);
                        padding: 4px 10px;
                        border-radius: 20px;
                        margin-bottom: 8px;
                        font-weight: 500;
                    }

                    h4 {
                        margin: 0;
                        font-size: 17px;
                        font-weight: 600;
                        color: #333;
                        line-height: 1.4;
                    }
                }

                .referral-badges {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;

                    .source-badge,
                    .status-badge {
                        font-size: 11px;
                        font-weight: 500;
                        padding: 5px 10px;
                        border-radius: 20px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .source-badge {
                        background-color: #e0f2fe;
                        color: #0284c7;

                        &.ad {
                            background-color: #eff6ff;
                            color: #3b82f6;
                            border: 1px solid rgba(59, 130, 246, 0.2);
                        }
                    }

                    .status-badge {
                        &.active {
                            background-color: #ecfdf5;
                            color: #059669;
                            border: 1px solid rgba(16, 185, 129, 0.2);
                        }

                        &.paused {
                            background-color: #fffbeb;
                            color: #d97706;
                            border: 1px solid rgba(217, 119, 6, 0.2);
                        }

                        &.archived {
                            background-color: #f3f4f6;
                            color: #6b7280;
                            border: 1px solid rgba(107, 114, 128, 0.2);
                        }
                    }
                }
            }

            .referral-body {
                padding: 20px;
                flex: 1;

                p {
                    margin: 0 0 20px;
                    font-size: 14px;
                    color: #555;
                    line-height: 1.6;
                }

                .ad-details {
                    background-color: #f9fafb;
                    border-radius: 10px;
                    padding: 16px;
                    display: flex;
                    flex-direction: column;
                    gap: 14px;

                    .detail-item {
                        display: flex;
                        flex-direction: column;
                        gap: 4px;

                        .detail-label {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            font-size: 12px;
                            color: #666;
                            font-weight: 500;

                            i {
                                font-size: 12px;
                                width: 18px;
                                height: 18px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #674ea7;
                                background-color: rgba(103, 78, 167, 0.08);
                                border-radius: 4px;
                                padding: 8px;
                            }
                        }

                        .detail-value {
                            font-size: 14px;
                            font-weight: 500;
                            color: #333;
                            padding-left: 34px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            cursor: default;
                        }
                    }
                }
            }

            .referral-footer {
                padding: 14px 20px;
                border-top: 1px solid #f0ebff;
                background-color: #fcfbff;
                text-align: right;

                .view-link {
                    font-size: 13px;
                    color: #674ea7;
                    text-decoration: none;
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 8px 14px;
                    border-radius: 6px;
                    background-color: rgba(103, 78, 167, 0.08);
                    transition: all 0.2s ease;
                    font-weight: 500;

                    &:hover {
                        background-color: rgba(103, 78, 167, 0.15);
                        color: #563d9f;
                    }

                    i {
                        font-size: 12px;
                    }
                }
            }
        }
    }
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 1200px) {
    .meta-referral-list {
        .referrals-container {
            grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        }
    }
}

@media (max-width: 768px) {
    .meta-referral-list {
        padding: 16px;
        
        .meta-referral-header {
            flex-direction: column;
            align-items: stretch;
            padding: 16px;
            
            .meta-referral-filter {
                flex-direction: column;
                
                input, select {
                    width: 100%;
                }
            }
        }

        .referrals-container {
            grid-template-columns: 1fr;
            gap: 16px;
            
            .referral-card {
                .referral-header, 
                .referral-body,
                .referral-footer {
                    padding: 16px;
                }
            }
        }
    }
}
</style>
